import React__default, { useMemo } from 'react';
import classnames from 'classnames';
import { connectRefinementList } from 'react-instantsearch-core';
import { Accordion, AccordionItem } from '@grandvisionhq/common';
import { filterFacetOption } from '../../utils/filter-facet-option.js';
import { orderFacetOptions } from '../../utils/order-facet-options.js';
import RefinementItem from '../RefinementItem/RefinementItem.js';
import FacetContainerMobile from './FacetContainerMobile.js';

const ConnectedFacetContainerMobile = ({ facet , items , refine , isActive , onChange , searchable , searchForItems , isFromSearch , expandedState , label ,  })=>{
    const sortedItems = useMemo(()=>{
        if (!items.length && !isFromSearch) {
            return [];
        }
        return orderFacetOptions({
            facet,
            items
        }).filter((item)=>filterFacetOption(item, facet)
        );
    }, [
        facet,
        items,
        isFromSearch
    ]);
    if (!items.length && !isFromSearch) {
        return null;
    }
    const facetListClass = classnames('connected-facet-container-mobile', {
        'connected-facet-container-mobile--hidden': expandedState && !isActive
    });
    return /*#__PURE__*/ React__default.createElement(Accordion, {
        className: "facets-mobile__accordion"
    }, /*#__PURE__*/ React__default.createElement(AccordionItem, {
        id: facet.id,
        className: "facets-mobile__accordion__item",
        label: label,
        headingLevel: "h3"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: facetListClass
    }, /*#__PURE__*/ React__default.createElement(FacetContainerMobile, {
        onSearch: searchable ? searchForItems : undefined,
        refineCount: items.filter((x)=>x.isRefined
        ).length,
        onClear: handleClear,
        isActive: isActive
    }, /*#__PURE__*/ React__default.createElement("fieldset", null, sortedItems.map((item)=>/*#__PURE__*/ React__default.createElement(RefinementItem, {
            key: item.label,
            item: item,
            facet: facet,
            onRefine: refine,
            onChange: onChange
        })
    ))))));
    function handleClear() {
        refine([]);
    }
};
var ConnectedFacetContainerMobile$1 = connectRefinementList(ConnectedFacetContainerMobile);

export { ConnectedFacetContainerMobile, ConnectedFacetContainerMobile$1 as default };
//# sourceMappingURL=ConnectedFacetContainerMobile.js.map
